import { CSSProperties } from 'react'
import styled from 'styled-components'

import { Typography } from 'primsell-shared-layer/components/atoms/typography'

interface RewardStatusContainerProps {
  backgroundColor: CSSProperties['backgroundColor']
}

interface StatusTextProps {
  textcolor: CSSProperties['color']
}

export const RewardStatusContainer = styled.div<RewardStatusContainerProps>`
  display: inline-block;
  min-width: 71px;
  padding: 3px 10px;
  border-radius: 10px;

  background-color: ${({ backgroundColor }) => backgroundColor};
`

export const StatusText = styled(Typography)<StatusTextProps>`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${({ textcolor }) => textcolor};
`
